import { api } from "./api";

export async function newPassword(id: string, new_password: string){
  try {
    const {data} = await api.put(`/player/password?player=${id}&new_password=${new_password}&code=y6z3D6H`);
    return data;
  }catch (error) {
    console.error("Erro ao redefinir senha:", error);
    throw error;
  }
}  